import { Service } from '../../exports/Orchestrator/channelConnections/types'

export const RESTRICTED_SERVICES_FOR_MP_USERS = [
  Service.mastodon,
  Service.tiktok,
  Service.youtube,
  Service.threads,
  Service.bluesky,
]
